import React from 'react';
import { Crown, ShieldCheck, Swords, Users, X } from 'lucide-react';

const data = (iso) => {
  try { return new Date(iso).toLocaleDateString('pt-BR'); } catch (e) { return ''; }
};

// Convite de clã por link: o jogador vê o clã e decide. Sem aceitar, não entra.
export const GbClanInvite = ({ convite, entrando, onAccept, onDecline }) => {
  const c = convite?.clan || {};
  const cor = c.hex || '#fbbf24';
  const cheio = !!convite?.full;
  const jaTem = !!convite?.already_in_clan;
  const bloqueado = cheio || jaTem;

  return (
    <div className="fixed inset-0 z-[85] flex items-end justify-center bg-black/88 p-3 backdrop-blur-sm sm:items-center"
      data-testid="gb-clan-invite">
      <div className="w-full max-w-md overflow-hidden rounded-3xl border bg-gradient-to-b from-[#1a1028] via-[#120a1d] to-black shadow-[0_0_60px_rgba(0,0,0,.8)]"
        style={{ borderColor: `${cor}66` }}>
        <div className="relative px-5 pb-4 pt-6 text-center"
          style={{ background: `radial-gradient(ellipse at 50% -40%, ${cor}33, transparent 70%)` }}>
          <button onClick={onDecline} data-testid="gb-clan-invite-close"
            className="absolute right-3 top-3 rounded-full border border-purple-700/60 p-1.5 text-purple-300 transition-colors hover:border-rose-600 hover:text-rose-200">
            <X className="h-3.5 w-3.5" />
          </button>
          <p className="text-[10px] font-black uppercase tracking-[0.3em] text-amber-300/90">
            convite de clã
          </p>
          {c.medal_img && (
            <img src={c.medal_img} alt="" data-testid="gb-clan-invite-medal"
              className="mx-auto mt-3 h-20 w-20 object-contain drop-shadow-[0_6px_20px_rgba(0,0,0,.7)]" />
          )}
          <h3 className="mt-2 text-xl font-black leading-tight" style={{ color: cor }}
            data-testid="gb-clan-invite-name">
            {c.name}
          </h3>
        </div>

        <div className="space-y-2.5 px-5 pb-3">
          <div className="flex items-center gap-2.5 rounded-2xl border border-purple-800/60 bg-black/40 px-3 py-2.5"
            data-testid="gb-clan-invite-leader">
            {c.leader_avatar
              ? <img src={c.leader_avatar} alt="" className="h-11 w-11 flex-none rounded-full border-2 object-cover"
                style={{ borderColor: cor }} />
              : <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full border-2 bg-purple-900 text-base"
                style={{ borderColor: cor }}>🎃</span>}
            <div className="min-w-0 flex-1">
              <p className="flex items-center gap-1 text-[9px] font-black uppercase tracking-[0.18em] text-amber-400/80">
                <Crown className="h-3 w-3" />líder do clã
              </p>
              <p className="truncate text-sm font-black text-amber-100">{c.leader_nickname}</p>
              <p className="text-[10px] font-bold text-purple-300/60">Nv {c.leader_level || 1}</p>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2">
            {[
              { Icon: Users, v: `${c.members_count || 0}/${c.max_members || 30}`, t: 'membros' },
              { Icon: Swords, v: (c.pvp_wins || 0).toLocaleString('pt-BR'), t: 'vitórias pvp' },
              { Icon: ShieldCheck, v: data(c.created_at), t: 'fundado em' },
            ].map(({ Icon, v, t }) => (
              <div key={t} className="rounded-2xl border border-purple-800/60 bg-black/40 px-2 py-2 text-center">
                <Icon className="mx-auto h-3.5 w-3.5 text-purple-300/70" />
                <p className="mt-1 truncate text-xs font-black text-amber-100">{v}</p>
                <p className="text-[8px] font-bold uppercase tracking-wider text-purple-400/70">{t}</p>
              </div>
            ))}
          </div>

          {jaTem && (
            <p className="rounded-2xl border border-amber-700/50 bg-amber-950/30 px-3 py-2 text-[11px] font-bold text-amber-200"
              data-testid="gb-clan-invite-warn">
              Você já está no clã {convite.my_clan_name}. Saia dele antes de aceitar outro convite.
            </p>
          )}
          {cheio && !jaTem && (
            <p className="rounded-2xl border border-rose-700/50 bg-rose-950/30 px-3 py-2 text-[11px] font-bold text-rose-200"
              data-testid="gb-clan-invite-warn">
              Esse clã já está lotado ({c.max_members} membros).
            </p>
          )}
        </div>

        <div className="flex items-center gap-2 border-t border-purple-900/70 px-5 py-4">
          <button onClick={onDecline} data-testid="gb-clan-invite-decline"
            className="flex-1 rounded-2xl border border-purple-700/60 py-3 text-xs font-black uppercase tracking-wide text-purple-200 transition-colors hover:border-rose-600 hover:text-rose-200">
            recusar
          </button>
          <button onClick={onAccept} disabled={bloqueado || entrando}
            data-testid="gb-clan-invite-accept"
            className="flex-[1.4] rounded-2xl bg-gradient-to-r from-orange-600 via-orange-500 to-amber-400 py-3 text-xs font-black uppercase tracking-wide text-[#1b0d02] shadow-[0_0_26px_rgba(255,107,0,.4)] transition-transform hover:scale-[1.02] disabled:opacity-40 disabled:shadow-none disabled:hover:scale-100">
            {entrando ? 'entrando…' : 'aceitar e entrar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GbClanInvite;
